import styled from 'styled-components';

export const Container = styled.div`
  min-height: calc(100vh - 56px);
  background: ${(props) => props.theme.$gray100};
  color: ${(props) => props.theme.$gray800};
  line-height: normal;

  /* Tamanhos e pesos da plataforma (Roboto 400/700), como na área do embaixador. */
  .feedback-card {
    padding: 1.5rem 1.5rem 2rem;
    border-radius: 8px;
    background: ${(props) => props.theme.$white};
    box-shadow: 0px 0px 5px rgba(94, 118, 172, 0.1);
  }

  .feedback-heading {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 16px;
    margin-bottom: 8px;

    h1 {
      margin: 0;
      color: ${(props) => props.theme.$gray900};
      font-size: 24px;
      font-weight: 600;
      line-height: normal;
    }
  }

  .feedback-section {
    margin: 0;
    padding: 20px 0 24px;
    border-bottom: 1px solid #f0f0f0;

    .feedback-question,
    label {
      display: block;
      margin: 0 0 12px;
      color: ${(props) => props.theme.$gray800};
      font-size: 16px;
      font-weight: 700;
      line-height: normal;
    }
  }

  .feedback-comment {
    margin-bottom: 0;
    padding-bottom: 20px;
    border-bottom: 0;
  }

  .feedback-options {
    display: flex;
    flex-wrap: wrap;
    gap: 14px;

    button {
      padding: 10px 24px;
      border: 1px solid ${(props) => props.theme.$gray400};
      border-radius: 6px;
      background: ${(props) => props.theme.$white};
      color: ${(props) => props.theme.$gray800};
      font-size: 14px;
      font-weight: 400;
      line-height: normal;
      transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;

      &:hover:not(:disabled) {
        border-color: ${(props) => props.theme.$dark_green};
      }

      &:focus-visible {
        box-shadow: 0 0 0 3px rgba(13, 135, 94, 0.35);
      }

      &.selected {
        border-color: ${(props) => props.theme.$dark_green};
        background: ${(props) => props.theme.$dark_green};
        color: ${(props) => props.theme.$white};
        font-weight: 700;
      }

      &:disabled {
        cursor: not-allowed;
        opacity: 0.7;
      }
    }
  }

  /* Escala de 0 a 10, como a pesquisa de satisfação da home; os rótulos ficam nas pontas. */
  .feedback-scale {
    display: inline-flex;
    flex-direction: column;
    gap: 8px;
    max-width: 100%;
  }

  .feedback-rating {
    gap: 8px;

    button {
      min-width: 44px;
      padding: 10px 0;
    }
  }

  .feedback-scale-labels {
    display: flex;
    justify-content: space-between;
    color: ${(props) => props.theme.$gray600};
    font-size: 13px;
  }

  textarea {
    display: block;
    width: 100%;
    height: 150px;
    padding: 20px 15px;
    border: 1px solid ${(props) => props.theme.$gray400};
    border-radius: 8px;
    color: ${(props) => props.theme.$gray800};
    font-size: 14px;
    font-weight: 400;
    line-height: 1.4;
    resize: vertical;

    &::placeholder {
      color: ${(props) => props.theme.$gray600};
    }

    &:focus {
      border-color: ${(props) => props.theme.$dark_green};
    }
  }

  .feedback-submit {
    display: flex;
    justify-content: flex-end;
    margin-top: 8px;
  }

  .feedback-sent {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    padding: 48px 18px 8px;
    text-align: center;

    .material-icons {
      color: ${(props) => props.theme.$dark_green};
      font-size: 56px;
    }

    strong {
      font-size: 18px;
      font-weight: 700;
    }

    p {
      margin: 0;
      font-size: 14px;
    }
  }

  .feedback-sent-actions {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 16px;
    margin-top: 24px;
  }

  .director-card {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin-top: 28px;
    padding: 20px 18px;
    border: 1px solid ${(props) => props.theme.$gray400};
    border-radius: 8px;
    background: ${(props) => props.theme.$white};

    a {
      gap: 10px;
    }
  }

  .director-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-size: 14px;

    strong {
      font-size: 16px;
      font-weight: 700;
    }
  }

  @media only screen and (max-width: 768px) {
    /* No celular a escala vira uma linha só, ocupando a largura. */
    .feedback-scale {
      display: flex;
    }

    .feedback-rating {
      flex-wrap: nowrap;
      gap: 4px;

      button {
        flex: 1;
        min-width: 0;
        padding: 10px 0;
      }
    }
  }
`;
